module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAABUUlEQVQ4T62UPyiFYRTGf4+wGWRhUCIMBoVFiSxkMJEyKIkyGJSF8idFWYxMDDdGozBZlSzKxma9JlmU++jVd/Xdz5eu+znLW2/P+XWe857zynYLcA40Aqby+ACWZHsR2ATWMgKngZsAnAdmJA1VXhzY3gr5ReCspIHfgLZHIhcvkiaTWtvbQOEvwAngDHiU1PHvQNv7QDdwIimXuULbV8AosC5ptyyg7WugBlgBmuOWKwXmgQZgODq/e1gW0HYbcBg1fA64zwrsAh4iYIDfZgWGcchFwCngFKgFloF6IAxvXtK47QOgBziWdBR/lAUgbEt/xtXbA97CYI8BF8BrRmAdsKFgz/Yg0JQCfI/sJ3+h0Iav3FiE3+YyeVmisH0H9KbseLukp7Td/wG0XRWrNLxyX0piZ9jp6F6SCkVNCdD2KrCTsB6sJKM6pnmW1FoUfAKfTeGxDXzWGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin/uavDataStatistics.png
// module id = Awa9
// module chunks = 2